/**
 * @fileoverview メカニカルセクションの制御スクリプト
 * @description メカニカルコンテンツの選択・切り替え機能とスライダー制御を行います。
 *
 * @overview
 * - メカニカルセレクターボタンのクリックでコンテンツ切り替え
 * - アクティブなメカニカルコンテンツのスライダー管理
 * - アクセシビリティ対応（aria-hidden属性）
 */

import {
	mountMechanicalSlider,
	destroyMechanicalSlider
} from './_slider.js';

/**
 * メカニカルセクションの初期化処理
 */
const initMechanical = () => {
	/** メカニカルセレクターボタンの要素コレクション */
	const selectors = document.querySelectorAll(
		'.p-home-mechanical__selector-item:not(.is-placeholder)'
	);

	/** メカニカルコンテンツの要素コレクション */
	const contents = document.querySelectorAll(
		'.p-home-mechanical__content'
	);

	/**
	 * アクセシビリティ対応のためのaria-hidden属性を更新
	 * @param {Element} activeArticle - アクティブなコンテンツ要素
	 */
	const updateAria = (activeArticle) => {
		contents.forEach(article => {
			article.setAttribute(
				'aria-hidden',
				String(article !== activeArticle)
			);
		});
	};

	/**
	 * メカニカルコンテンツを切り替え
	 * @param {string} targetId - 切り替え先のコンテンツID
	 */
	const switchMechanical = (targetId) => {
		const targetArticle = document.getElementById(targetId);
		if (!targetArticle) return;

		// セレクターボタンのアクティブ状態を更新
		selectors.forEach(btn => {
			btn.classList.toggle(
				'is-active',
				btn.dataset.target === targetId
			);
		});

		// すべてのコンテンツを非アクティブにし、初期表示用フラグを削除
		contents.forEach(article => {
			article.classList.remove('is-active', 'is-fade');
			article.classList.remove('is-initial');
		});

		// 既存のスライダーを破棄
		destroyMechanicalSlider();

		// 新しいコンテンツをアクティブに
		targetArticle.classList.add('is-active');
		requestAnimationFrame(() => targetArticle.classList.add('is-fade'));
		updateAria(targetArticle);
		mountMechanicalSlider(targetArticle);
	};

	// 初期表示のアクティブコンテンツを取得して設定
	const initial = document.querySelector(
		'.p-home-mechanical__content.is-active'
	);

	if (initial) {
		updateAria(initial);
		initial.classList.add('is-initial');
		mountMechanicalSlider(initial);
	}

	// セレクターボタンにクリックイベントを追加
	selectors.forEach(btn => {
		btn.addEventListener('click', () => {
			const target = btn.dataset.target;
			if (target) switchMechanical(target);
		});
	});
};

/**
 * DOMの読み込み状態に応じて初期化関数を実行
 * - 読み込み中の場合はDOMContentLoadedイベントを待つ
 * - 既に読み込み済みの場合は即時実行
 */
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initMechanical);
} else {
	initMechanical();
}
